//<!-- AppState.js -->
import { writable } from 'svelte/store';

export const showTips = writable(true);
export const showExamples = writable(false);
export const sidebarOpen = writable(true); // New store for sidebar state

export let pathID = writable(0); // New store for pathID